import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Market, Markets } from './Market'

export const ListOfMarketValidation = z.object({
  list: z.instanceof(Market, { message: '[ListOfMarket] list is required' }).array(),
})

export class ListOfMarket extends Model {
  static create({ list }: z.infer<typeof ListOfMarketValidation>) {
    ListOfMarketValidation.parse({ list })
    return new ListOfMarket(list)
  }

  static empty() {
    return new ListOfMarket([])
  }

  static fromArray({ markets }: { markets: Markets[] }) {
    return ListOfMarket.create({ list: markets.map(market => Market.create({ value: market })) })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfMarket['toJSON']> }) {
    return ListOfMarket.create({
      list: json.list.map(marketJson => Market.fromJSON(marketJson)),
    })
  }

  constructor(private readonly _list: Market[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  has({ market }: { market: Market }) {
    if (!market.isFilled()) return false

    return this._list.some(internalMarket => internalMarket.is(market.value))
  }

  isEmpty() {
    return this._list.length === 0
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }
}
